import { useRef, type ReactNode } from 'react';

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

const SIZES = {
  sm: 'sm:max-w-sm',
  md: 'sm:max-w-md',
  lg: 'sm:max-w-2xl',
};

export function Modal({ open, title, onClose, children, size = 'md' }: Props) {
  // fecha clicando fora SÓ se o clique começou E terminou no backdrop —
  // arrastar uma seleção de texto de dentro pra fora não pode fechar o modal
  const downOnBackdrop = useRef(false);

  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex items-end justify-center bg-slate-900/50 sm:items-center sm:p-4"
      onMouseDown={(e) => {
        downOnBackdrop.current = e.target === e.currentTarget;
      }}
      onClick={(e) => {
        if (downOnBackdrop.current && e.target === e.currentTarget) onClose();
        downOnBackdrop.current = false;
      }}
    >
      <div
        className={`flex h-[100dvh] w-full flex-col overflow-hidden bg-white shadow-xl sm:h-auto sm:max-h-[90vh] sm:rounded-xl sm:border sm:border-slate-200 ${SIZES[size]}`}
      >
        <div className="safe-pt flex items-center justify-between border-b border-slate-100 px-4 py-3 sm:border-b-0 sm:pb-0">
          <h2 className="text-base font-semibold sm:text-lg">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="tap rounded-md text-slate-400 hover:bg-slate-100"
            aria-label="fechar"
          >
            ✕
          </button>
        </div>
        <div className="safe-pb flex-1 overflow-y-auto px-4 py-4 sm:p-6">{children}</div>
      </div>
    </div>
  );
}
